<template>
  <v-container fluid fill-height id="login-page">
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>

        <transition name="fade" mode="out-in">
          <v-card class="elevation-12">

            <v-card-text>
              <div class="text-center mb-4">
                <img src="../assets/logo.png" alt="uCamp.it"/>
              </div>

              <!-- Login Form -->
              <form v-if="!forgotMode" ref="form" @submit.prevent="tryLogin()">
                <v-text-field
                    v-model="email" name="email" label="Email" type="text" placeholder="Email" required
                    prepend-icon="mdi-account"
                ></v-text-field>

                <v-text-field
                    v-model="password" name="password" label="Password"
                    :type="showPass ? 'text' : 'password'" placeholder="Password" required
                    :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPass = !showPass" prepend-icon="mdi-lock"
                ></v-text-field>

                <v-checkbox v-model="rememberMe" :label="$t('rememberMe')" color="primary" dense></v-checkbox>

                <div class="text-center mb-2">
                  <v-btn color="primary" large type="submit" block>{{ $t('sign_in') }}</v-btn>
                </div>

                <div class="text-center">
                  <v-btn text small color="primary" @click="forgotMode = true">
                    Password dimenticata?
                  </v-btn>
                </div>
              </form>

              <!-- Forgot Password Form -->
              <form v-else @submit.prevent="sendResetEmail()">
                <v-text-field
                    v-model="email" name="forgot-email" label="Inserisci la tua email"
                    type="email" placeholder="Email" required prepend-icon="mdi-email"
                ></v-text-field>

                <div class="text-center mb-2">
                  <v-btn color="primary" large type="submit" block>Invia richiesta</v-btn>
                </div>

                <div class="text-center">
                  <v-btn text small color="primary" @click="forgotMode = false">
                    Torna al login
                  </v-btn>
                </div>
              </form>

            </v-card-text>

          </v-card>
        </transition>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

export default {
  name: 'Login',
  data: () => ({
    email: '',
    password: null,
    showPass: false,
    rememberMe: false,
    forgotMode: false
  }),
  methods: {
    ...mapActions({
      login: 'user/login',
      resetPassword: 'user/resetPassword',
    }),
    ...mapMutations({
      setLoading: 'settings/setLoading',
      setNotification: 'settings/setNotification',
    }),

    async tryLogin() {
      this.setLoading(true);
      try {
        const result = await this.login({
          email: this.email,
          password: this.password,
          rememberMe: this.rememberMe
        });

        this.setLoading(false);

        if (result.success) {
          // UCAMP-87 plan 9: torna alla pagina richiesta prima del login, solo se interna all'admin
          const redirect = this.$route.query.redirect;
          const safe = typeof redirect === 'string' && redirect.startsWith('/') && !redirect.startsWith('//');
          this.$router.push(safe ? redirect : '/dashboard');
        } else {
          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: this.$t(result.message)
          });
        }
      } catch (e) {
        this.setLoading(false);
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: this.$t(e.message)
        });
      }
    },

    async sendResetEmail() {
      this.setLoading(true);

      try {
        const result = await this.resetPassword({
          email: this.email
        });

        if(result.success){
          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: 'Email di recupero password inviata con successo!'
          });
          this.forgotMode = false;

        }else {
          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: (result.message === 'email_not_valid') ? 'Email non associata ad alcun account. Per favore, riprova con un\'altra email ' : result.message
          });
        }

        this.setLoading(false);

      } catch (e) {
        this.setLoading(false);
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: 'Errore durante l\'invio dell\'email.'
        });
      }
    }
  }
}
</script>


<style scoped>
#login-page {
  background-color: #222b54;
}
</style>